import type { CSSProperties } from "react";

export type ToneKey =
  | "violet" | "teal" | "amber" | "rose" | "blue" | "emerald" | "orange"
  | "brown" | "danger" | "muted" | "indigo" | "fuchsia" | "sky"
  | "lime" | "gold" | "slate" | "crimson";

export const TONE_TOKENS: Record<ToneKey, { primary: string; strength: string }> = {
  violet: { primary: "--primary", strength: "88%" },
  teal: { primary: "--chart-2", strength: "86%" },
  amber: { primary: "--chart-4", strength: "86%" },
  rose: { primary: "--chart-5", strength: "86%" },
  blue: { primary: "--chart-1", strength: "86%" },
  emerald: { primary: "--success", strength: "86%" },
  orange: { primary: "--warning", strength: "86%" },
  brown: { primary: "--muted-foreground", strength: "68%" },
  danger: { primary: "--destructive", strength: "88%" },
  muted: { primary: "--muted", strength: "55%" },
  indigo: { primary: "--primary", strength: "84%" },
  fuchsia: { primary: "--chart-5", strength: "84%" },
  sky: { primary: "--chart-1", strength: "82%" },
  lime: { primary: "--success", strength: "82%" },
  gold: { primary: "--chart-4", strength: "84%" },
  slate: { primary: "--muted-foreground", strength: "72%" },
  crimson: { primary: "--destructive", strength: "86%" },
};

export const BG_TO_TONE: Record<string, ToneKey> = {
  "bg-violet-500": "violet", "bg-teal-500": "teal", "bg-amber-500": "amber",
  "bg-rose-500": "rose", "bg-sky-500": "blue", "bg-emerald-500": "emerald",
  "bg-emerald-600": "emerald", "bg-orange-500": "orange", "bg-fuchsia-500": "fuchsia",
  "bg-indigo-500": "indigo", "bg-lime-500": "lime", "bg-pink-500": "rose",
  "bg-purple-500": "crimson", "bg-slate-400": "slate", "bg-slate-500": "slate",
  "bg-stone-500": "brown", "bg-yellow-500": "gold", "bg-red-500": "danger",
  "bg-muted": "muted",
};

export const TILE_SURFACE_FILL_CLS =
  "bg-[color-mix(in_oklab,var(--tile-accent)_var(--tile-strength),hsl(var(--card)))] text-foreground";

export const TILE_SURFACE_CLS =
  `${TILE_SURFACE_FILL_CLS} ring-1 ring-inset ring-white/10`;

export const TILE_MUTED_SURFACE_CLS =
  "bg-muted/40 text-foreground ring-1 ring-inset ring-border/50";

export function toneStyle(bgClass: string): CSSProperties | undefined {
  const tone = BG_TO_TONE[bgClass];
  if (!tone) return undefined;
  const definition = TONE_TOKENS[tone];
  return {
    ["--tile-accent" as string]: `hsl(var(${definition.primary}))`,
    ["--tile-strength" as string]: definition.strength,
  };
}
